import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getRequestStatus } from 'state/requests/RequestStatusSelectors';
import { getView } from 'state/view/ViewSelectors';
import { REQUEST_STATES } from 'state/requests/RequestStatusReducer';

const TestAndTarget = (WrappedComponent, mBox, atProperty) => {
  class GetTestData extends Component {
    constructor(props) {
      super(props);
      this.state = {
        offer: null,
        action: null,
        fetchedOffer: false
      };

      this.getMessage = this.getMessage.bind(this);
    }

    componentDidMount() {
      const { fetchedOffer } = this.state;
      const { requestStatus } = this.props;
      if (!fetchedOffer && requestStatus.accounts === REQUEST_STATES.received) {
        this.getMessage();
      }
    }

    componentDidUpdate() {
      const { fetchedOffer } = this.state;
      const { requestStatus } = this.props;
      if (!fetchedOffer && requestStatus.accounts === REQUEST_STATES.received) {
        this.getMessage();
      }
    }

    getMessage = () => {
      this.setState({ fetchedOffer: true });
      const {
        view: { hasCollegeSavingsOnly }
      } = this.props;
      let promise = new Promise((resolve) => {
        if (window && window.adobe) {
          window.adobe.target.getOffer({
            mbox: mBox,
            params: {
              at_property: atProperty,
              is529Only: hasCollegeSavingsOnly
            },
            success: function (offer) {
              offer.forEach((item) => {
                if (item.action && item.action.indexOf('html') > 0) {
                  resolve(item);
                } else if (item.action && item.action === 'setJson') {
                  resolve(item);
                }
              });
            },
            error: function () {
              //eslint-disable-no-empty
            }
          });
        }
      });

      promise
        .then((item) => {
          this.setState({ offer: item.content[0], action: item.action });
        })
        .catch(() => {
          //eslint-disable-no-empty
        });
    };

    render() {
      const { offer, action } = this.state;
      const { ...passThroughProps } = this.props;

      if (!action) {
        return <WrappedComponent {...passThroughProps} />;
      }

      if (action && action.indexOf('html') > 0 && offer) {
        return <div dangerouslySetInnerHTML={{ __html: offer }} />;
      }

      if (action === 'setJson' && offer) {
        return <WrappedComponent {...offer} isMarketingTest={true} />;
      }
    }
  }
  const mapStateToProps = (state) => ({
    view: getView(state),
    requestStatus: getRequestStatus(state)
  });
  return connect(mapStateToProps)(GetTestData);
};

export default TestAndTarget;
